import * as FaBrandsIcons from '@awesome.me/kit-7aa565e995/icons/modules/classic/brands'
import * as FaIcons from '@awesome.me/kit-7aa565e995/icons/modules/classic/solid'
import * as FaKit from '@awesome.me/kit-7aa565e995/icons/modules/kit/custom'
import * as FaRegularIcons from '@awesome.me/kit-7aa565e995/icons/modules/classic/regular'

export { FaBrandsIcons, FaIcons, FaKit, FaRegularIcons }
